var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-decorated-title",class:{'g-texta-c': _vm.center}},[_c('div',{staticClass:"g-fontw-600"},[_vm._t("default")],2),_c('div',{staticClass:"c-decorated-title-l",style:({marginTop: _vm.gap})},[_c('div',{staticClass:"c-decorated-title-l g-display-ib"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }